const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjIiLz4KPHJlY3QgeD0iMTMiIHk9IjIiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHJ4PSIyIi8+CjxyZWN0IHg9IjIiIHk9IjEzIiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiByeD0iMiIvPgo8cmVjdCB4PSIxMyIgeT0iMTMiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHJ4PSIyIi8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=grid-5f613fef.mjs.map
